import React from 'react';
import BasicDropdown from '../../base/dropdowns/basic-dropdown';

export const formatStr = string => string.replace(/ /g, '-').toLowerCase();

const FormItem = ({ label, value, setter, items, className }) => {
  const formattedLabel = formatStr(label);
  const classLabel = !className ? formattedLabel : formatStr(className);

  return !items ? (
    <div className={`form-item ${classLabel}`}>
      <label>{label}</label>
      <div className="form-item-width">
        <input
          type="text"
          className={formattedLabel}
          value={value}
          onChange={e => setter(e.target.value)}
        />
      </div>
    </div>
  ) : (
    <div className="form-item">
      <label>{label}</label>
      <div className={classLabel}>
        <BasicDropdown
          items={items}
          selectItem={idx => setter(items[idx])}
          dropdownLabel={value.label}
        />
      </div>
    </div>
  );
};

export default FormItem;
